export class LSProductStoryVideo extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.video = this.querySelector('video');
    this.button = this.querySelector('.ls-product-story__control');
    if (!this.video || !this.button) return;

    this.userPaused = false;
    this.isVisible = false;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onButtonClick = () => this.togglePlayback();
    this.onVisibilityChange = () => this.updateAutoPlayback();
    this.onMotionChange = () => this.updateAutoPlayback();
    this.onVideoStateChange = () => this.syncState();

    this.button.addEventListener('click', this.onButtonClick);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.motionQuery.addEventListener?.('change', this.onMotionChange);
    this.video.addEventListener('play', this.onVideoStateChange);
    this.video.addEventListener('pause', this.onVideoStateChange);

    this.observer = new IntersectionObserver(([entry]) => {
      this.isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.45;
      this.updateAutoPlayback();
    }, { threshold: [0, 0.45, 0.8] });
    this.observer.observe(this);
    this.syncState();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.button?.removeEventListener('click', this.onButtonClick);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.motionQuery?.removeEventListener?.('change', this.onMotionChange);
    this.video?.removeEventListener('play', this.onVideoStateChange);
    this.video?.removeEventListener('pause', this.onVideoStateChange);
    this.video?.pause();
  }

  async play() {
    if (!this.video) return;
    try {
      await this.video.play();
    } catch {
      this.syncState();
    }
  }

  pause() {
    this.video?.pause();
  }

  togglePlayback() {
    if (this.video.paused) {
      this.userPaused = false;
      this.play();
    } else {
      this.userPaused = true;
      this.pause();
    }
  }

  updateAutoPlayback() {
    const shouldPlay = this.isVisible
      && document.visibilityState === 'visible'
      && !this.motionQuery.matches
      && !this.userPaused;
    if (shouldPlay) this.play();
    else this.pause();
  }

  syncState() {
    const isPlaying = Boolean(this.video && !this.video.paused);
    this.classList.toggle('is-playing', isPlaying);
    this.button?.setAttribute('aria-pressed', String(isPlaying));
    const label = isPlaying ? this.button?.dataset.pauseLabel : this.button?.dataset.playLabel;
    if (label) this.button?.setAttribute('aria-label', label);
  }
}

if (!customElements.get('ls-product-story-video')) {
  customElements.define('ls-product-story-video', LSProductStoryVideo);
}
